module.exports = __webpack_public_path__ + "materialdesignicons-webfont.woff2?459118748df2a5fcd7f684546cc8591b";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mdi/font/fonts/materialdesignicons-webfont.woff2?v=2.8.94
// module id = 1530
// module chunks = 0